import { assertValued } from './util';
export class SessionService {
    constructor(richSessionRemoteRepository) {
        this.richSessionRemoteRepository = richSessionRemoteRepository;
        this.sessionIdToSessionCache = new Map();
    }
    async getSession(sessionId) {
        if (!this.sessionIdToSessionCache.has(sessionId)) {
            const session = await this.richSessionRemoteRepository.fetchSession(sessionId);
            this.sessionIdToSessionCache.set(sessionId, session);
        }
        return assertValued(this.sessionIdToSessionCache.get(sessionId));
    }
    async getBestUsername(sessionId) {
        const session = await this.getSession(sessionId);
        return session.userUsername || session.username;
    }
}
